/* Garments and views. Add a garment here and its controls build themselves.
   brand: [x, y, width] as fractions of the view - nudge to move the NELY mark. */
window.KB_CONFIG.views = {
  "sj_f": {
    "gamma": 1.75,
    "label": "Front",
    "side": "front",
    "mode": "blend",
    "w": 698,
    "h": 900,
    "shade": "sj_f_s",
    "zone": "sj_f_z",
    "brand": [
      0.335,
      0.285,
      0.145
    ],
    "patternZones": [
      1,
      2
    ]
  },
  "sj_b": {
    "gamma": 1.75,
    "label": "Back",
    "side": "back",
    "mode": "blend",
    "w": 674,
    "h": 900,
    "shade": "sj_b_s",
    "zone": "sj_b_z",
    "patternZones": [
      1,
      2
    ],
    "nameY": 0.25,
    "numY": 0.455
  },
  "rj_f": {
    "gamma": 1.2,
    "label": "Front",
    "side": "front",
    "mode": "blend",
    "w": 699,
    "h": 900,
    "shade": "rj_f_s",
    "zone": "rj_f_z",
    "brand": [
      0.335,
      0.285,
      0.145
    ],
    "patternZones": [
      1,
      2
    ]
  },
  "rj_b": {
    "gamma": 1.2,
    "label": "Back",
    "side": "back",
    "mode": "blend",
    "w": 674,
    "h": 900,
    "shade": "rj_b_s",
    "zone": "rj_b_z",
    "patternZones": [
      1,
      2
    ],
    "nameY": 0.25,
    "numY": 0.455
  },
  "pv_f": {
    "gamma": 0.95,
    "label": "Front",
    "side": "front",
    "mode": "lb",
    "w": 583,
    "h": 900,
    "shade": "pv_f_s",
    "zone": "pv_f_z",
    "brand": [
      0.355,
      0.285,
      0.145
    ],
    "patternZones": [
      1
    ]
  },
  "pv_b": {
    "gamma": 0.95,
    "label": "Back",
    "side": "back",
    "mode": "lb",
    "w": 585,
    "h": 900,
    "shade": "pv_b_s",
    "zone": "pv_b_z",
    "patternZones": [
      1
    ],
    "nameY": 0.215,
    "numY": 0.415
  },
  "sh_f": {
    "gamma": 0.85,
    "label": "Front",
    "side": "front",
    "mode": "lb",
    "w": 786,
    "h": 760,
    "shade": "sh_f_s",
    "zone": "sh_f_z",
    "brand": [
      0.755,
      0.865,
      0.135
    ],
    "patternZones": [
      1
    ]
  },
  "sh_b": {
    "gamma": 0.85,
    "label": "Back",
    "side": "back",
    "mode": "lb",
    "w": 798,
    "h": 760,
    "shade": "sh_b_s",
    "zone": "sh_b_z",
    "patternZones": [
      1
    ]
  }
};
window.KB_CONFIG.garments = [
  {
    "id": "soccer-jersey",
    "name": "Soccer jersey",
    "sub": "Short sleeve V-neck",
    "part": "soccerjersey",
    "views": [
      "sj_f",
      "sj_b"
    ],
    "zones": [
      [
        1,
        "Body",
        "#0B3B24"
      ],
      [
        2,
        "Sleeves",
        "#0B3B24"
      ],
      [
        3,
        "Collar",
        "#C69A22"
      ],
      [
        4,
        "Cuffs",
        "#C69A22"
      ],
      [
        5,
        "Hem",
        "#C69A22"
      ],
      [
        6,
        "Inner",
        "#082318"
      ]
    ]
  },
  {
    "id": "rugby-jersey",
    "name": "Rugby jersey",
    "sub": "Raglan sleeve crew neck",
    "part": "rugbyjersey",
    "views": [
      "rj_f",
      "rj_b"
    ],
    "zones": [
      [
        1,
        "Body",
        "#0B3B24"
      ],
      [
        2,
        "Sleeves",
        "#8E1B2B"
      ],
      [
        3,
        "Collar",
        "#C69A22"
      ],
      [
        4,
        "Cuffs",
        "#C69A22"
      ],
      [
        5,
        "Hem",
        "#C69A22"
      ],
      [
        6,
        "Inner",
        "#082318"
      ]
    ]
  },
  {
    "id": "shorts",
    "name": "Match shorts",
    "sub": "Elastic waist, lined",
    "part": "shorts",
    "views": [
      "sh_f",
      "sh_b"
    ],
    "zones": [
      [
        1,
        "Body",
        "#0B3B24"
      ],
      [
        3,
        "Waistband",
        "#C69A22"
      ],
      [
        6,
        "Lining",
        "#F2F0EA"
      ],
      [
        7,
        "Stitching",
        "#C69A22"
      ]
    ]
  },
  {
    "id": "full-kit",
    "name": "Full kit",
    "sub": "Jersey and shorts together",
    "parts": [
      "soccerjersey",
      "shorts"
    ],
    "kit": [
      "sj_f",
      "sh_f"
    ],
    "views": [
      "sj_f"
    ],
    "zones": [
      [
        1,
        "Body",
        "#0B3B24"
      ],
      [
        2,
        "Sleeves",
        "#0B3B24"
      ],
      [
        3,
        "Trim",
        "#C69A22"
      ],
      [
        4,
        "Cuffs",
        "#C69A22"
      ],
      [
        5,
        "Hem",
        "#C69A22"
      ],
      [
        6,
        "Inner",
        "#082318"
      ],
      [
        7,
        "Stitching",
        "#C69A22"
      ]
    ]
  },
  {
    "id": "premium-vest",
    "name": "Premium vest",
    "sub": "Sleeveless, bound neck",
    "part": "premiumvest",
    "views": [
      "pv_f",
      "pv_b"
    ],
    "zones": [
      [
        1,
        "Body",
        "#0B3B24"
      ],
      [
        3,
        "Binding",
        "#C69A22"
      ],
      [
        6,
        "Inner",
        "#082318"
      ],
      [
        7,
        "Stitching",
        "#C69A22"
      ]
    ]
  }
];
